import React from 'react';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  let colorClass = 'bg-gray-100 text-gray-800';
  let text = status;

  switch (status) {
    case 'processing':
      colorClass = 'bg-yellow-100 text-yellow-800';
      text = 'Processing';
      break;
    case 'ready':
      colorClass = 'bg-green-100 text-green-800';
      text = 'Ready';
      break;
    case 'failed':
      colorClass = 'bg-red-100 text-red-800';
      text = 'Failed';
      break;
    default:
      break;
  }

  return (
    <span className={`${colorClass} text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full ${className}`}>
      {text}
    </span>
  );
};

export default StatusBadge;
